'use client'

/* eslint-disable arrow-body-style */

import React from 'react'
import Image from 'next/image'
import { useProductContext } from '@context/ProductContext/ProductContext' // Update the path accordingly
import styles from './stepCards.module.scss'

const ImageComponent = ({ firstItem }) => {
  const { stepCardItem } = useProductContext()

  return (
    <div className={styles.imageContainer}>
      <div className={styles.imageWrapper}>
        {/* Load the image dynamically based on the selected item */}
        <Image
          src={stepCardItem?.stepCardImage?.data?.attributes?.url || firstItem?.stepCardImage?.data?.attributes?.url}
          alt="Image Accordion"
          width={596}
          height={666}
          className={styles.image}
          loading="lazy"
        />
      </div>
    </div>
  )
}

export default ImageComponent
